import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../../configs/store';

interface TillTopMenuProps {
  isSecondScreen?: boolean
}

function TillTopMenu({ isSecondScreen=false } : TillTopMenuProps) {
  const selectedTimezone = useSelector((state: RootState) => state.odds.selectedTimezone);
  const [status, setStatus] = useState({ speed: 0.0, connection: 'offline' });
  const { t } = useTranslation();
  const [date, setDate] =useState(() => {
    const zonedDate = utcToZonedTime(new Date().toISOString(), selectedTimezone);
    return format(zonedDate, 'dd.M.yyyy');
  });

  const [timer, setTimer] = useState(() => {
    const zonedDate = utcToZonedTime(new Date().toISOString(), selectedTimezone);
    return format(zonedDate, 'HH:mm:ss');
  });

  useEffect(() => {
    if (navigator['connection'].effectiveType !== status.connection){
      setStatus({ speed: navigator['connection'].downlink, connection: navigator['connection'].effectiveType });
    }
  }, [navigator, timer]);

  const updateTimer = () => {
    const zonedDate = utcToZonedTime(new Date().toISOString(), selectedTimezone);
    const newTimer = format(zonedDate, 'HH:mm:ss');
    const newDate = !isSecondScreen ? format(zonedDate, 'dd.M.yyyy') : format(zonedDate, 'dd/M/yyyy');

    if (newTimer !== timer) {
      setTimer(newTimer);
    }
    if (newDate !== date){
      setDate(newDate);
    }
  };
  const timerInterval = setInterval(updateTimer, 1000);

  useEffect(() => {
    return () => {
      clearInterval(timerInterval);
    };
  }, [timerInterval]);

  return (
    <>
      <div className={
        classNames({
          'top-menu__item top-menu__item--clock top-menu__retail': true,
          'top-menu__retail--second-screen': isSecondScreen
        })
      }
      >
        <div className="top-menu__retail-container">
          <div className="top-menu__connection">
            <div className="top-menu__status">
              { t('topmenu.status') }
            </div>
            <div className="top-menu__status-name">{ `${ status.speed } MB/s` }</div>
            <div className={
              classNames({
                'top-menu__status-simbol': true,
                'top-menu__status-simbol--green': status.connection === '4g' && status.speed > 1,
                'top-menu__status-simbol--red': status.connection === 'slow-2g' || status.connection === 'offline' || status.speed === 0

              })
            }
            />
          </div>
          <span className={
            classNames({
              'top-menu__item--time': true,
              'top-menu__item--second-screen': isSecondScreen
            })
          }
          >{ timer }</span>
        </div>
        <span className={
          classNames({
            'top-menu__item--date': true,
            'top-menu__item--second-screen': isSecondScreen
          })
        }
        >{ date }</span>
      </div>
    </>
  );
}

export default TillTopMenu;
